import React from "react";

export default function RebuildNavigationPanels() {
  return null;
}